export default {"src":"/_next/static/media/yellow_flower.a9b5d34d.svg","height":362,"width":241,"blurWidth":0,"blurHeight":0};